import React, { ReactNode } from 'react';

/**
 * Props for the RequireAuthShell component
 */
export interface RequireAuthShellProps {
  /** Whether authentication is being checked */
  isLoading: boolean;
  /** Whether the user is authenticated */
  isAuthenticated: boolean;
  /** The content to render if authenticated */
  children: ReactNode;
  /** Optional CSS class name for the loading spinner container */
  className?: string;
}

/**
 * RequireAuthShell component
 * 
 * A pure presentational component that handles the UI for authentication requirements.
 * Shows a loading spinner while checking authentication status.
 * Renders children if user is authenticated.
 */
export const RequireAuthShell: React.FC<RequireAuthShellProps> = ({
  isLoading,
  isAuthenticated,
  children,
  className = ''
}) => {
  // Show loading spinner while checking auth status
  if (isLoading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${className}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // If user is authenticated, render children
  return isAuthenticated ? <>{children}</> : null;
}; 